import React from 'react';
import {useAppSelector} from 'src/redux/hooks';
import {parseRichText} from './parseRichText';
import {FormViewRow} from '../FormViewRow/FormViewRow';

export interface FormViewRichTextEditorProps {
  label: string;
  valueColor?: string;
  // @TODO: Update typings.
  value: any;
  description?: string;
}
export const FormViewRichTextEditor: React.FC<FormViewRichTextEditorProps> = ({
  label,
  value,
  valueColor,
  description,
}) => {
  const {accessToken} = useAppSelector(state => state.auth);
  return (
    <FormViewRow
      label={label}
      valueColor={valueColor}
      value={value && parseRichText(value as string, accessToken)}
      description={description}
    />
  );
};
